// src/lib/utils.js
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Alternative to cn() that preserves text color classes.
 * Use this when you need to ensure text colors are not removed by tailwind-merge.
 * Particularly useful for typography where you want to override default colors.
 */
export function cnTypography(...inputs) {
  // First, get all the classes
  const allClasses = clsx(inputs);

  // Extract text color classes (text-*, !text-*) with prefixes (dark:, hover:, sm:, etc.)
  // Note: This regex specifically matches color classes, not size classes like text-lg, text-xl, etc.
  const textColorRegex =
    /(?:(?:sm:|md:|lg:|xl:|2xl:|dark:|hover:|focus:|active:|group-hover:|group-focus:)*(!?text-(?:inherit|current|transparent|black|white|slate|gray|zinc|neutral|stone|red|orange|amber|yellow|lime|green|emerald|teal|cyan|sky|blue|indigo|violet|purple|fuchsia|pink|rose|primary|secondary|accent|muted|destructive|warning|success|info)(?:-\d{1,3})?(?:\/\d{1,3})?))/g;

  const textColors = allClasses.match(textColorRegex) || [];
  // Keep all unique text colors (preserves both light and dark mode colors)
  const uniqueTextColors = [...new Set(textColors)];

  // Remove all text colors from the string
  const withoutTextColors = allClasses.replace(textColorRegex, "");

  // Apply tailwind-merge to everything except text colors
  const merged = twMerge(withoutTextColors);

  // Add all unique text colors back if they exist
  return uniqueTextColors.length > 0
    ? `${merged} ${uniqueTextColors.join(" ")}`
    : merged;
}

export function getSystemTheme() {
  try {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    return mediaQuery.matches ? "dark" : "light";
  } catch (error) {
    console.error("Error detecting system theme:", error);
    return "light";
  }
}

export function addThemeListener(callback) {
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  const handler = (e) => callback(e.matches ? "dark" : "light");
  mediaQuery.addListener(handler);
  return () => mediaQuery.removeListener(handler);
}
